/*
 * @Descripttion: 
 * @Author: panyufeng
 * @Date: 2024-12-06 13:52:13
 * @LastEditors: panyufeng
 * @LastEditTime: 2024-12-06 15:20:52
 */
export const getTableConfig = () => {
  // table 通用属性
  const common = {
    // table 有多选时设置
    isSelection: false,
    // table loading
    loading: false,
    // table 是否为斑马纹
    stripe: true,
    // table 的高度
    height: null,
    tool: null,
    // table 的尺寸 medium / small / mini
    size: 'small',
    // table 是否开启索引
    isIndex: false,
    // table 索引 label
    indexLabel: '序号',
    // table 数据
    data: []
  }

  // table 分页
  const pagination = {
    // 是否展示分页
    isShow: true,
    // 总条数
    total: 0,
    // 每页显示条目个数
    pageSize: 20,
    // 当前页数
    currentPage: 1,
    // 每页显示个数选择器的选项设置
    pageSizes: [10, 20, 40, 80, 100]
  }

  // table 列数据
  const column = [
    {
      key: 'enterpriseCode',
      label: '公司编号',
      width: '140'
    },
    {
      key: 'companyName',
      label: '公司名称',
      width: '140'
    },
    {
      key: 'apiMsg',
      label: '关联违章API',
      width: '140'
    },
    {
      key: 'num',
      label: '记录数',
      width: '140'
    }
  ]

  return {
    ...common,
    pagination,
    column
  }
}